<mat-card class="cardWithShadow test">
  <mat-card-content class="p-24 cardWithShadow">
    <div class="row justify-content-between ">
      <div class="col-lg-4">
        <mat-form-field appearance="outline" class="w-100 hide-hint ">
          <input matInput placeholder="Search Hospital" />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="col-lg-4 d-flex align-items-center justify-content-end">
        <button mat-flat-button color="primary" class="cardWithShadow" (click)="addHospital()">
          <mat-icon>add</mat-icon>
          Add Hospital
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="cardWithShadow">
  <mat-card-content class="p-24">
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">#</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Name</th>
          <td mat-cell *matCellDef="let element">

            <p class="f-w-600 mat-subtitle-1 f-s-16 m-t-0">
              {{element.Name}}
            </p>
            <!-- <small class="mat-body-1 f-s-14">jaybhai</small> -->

          </td>
        </ng-container>
        <ng-container matColumnDef="Doctors">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Doctors</th>
          <td mat-cell *matCellDef="let element">

            <p class="f-w-600 mat-subtitle-1 f-s-16 m-t-0">
              33
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="OPDs">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">OPDs</th>
          <td mat-cell *matCellDef="let element">

            <p class="f-w-600 mat-subtitle-1 f-s-16 m-t-0">
              103
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="Patients">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Patients</th>
          <td mat-cell *matCellDef="let element">

            <p class="f-w-600 mat-subtitle-1 f-s-16 m-t-0">
              150
            </p>

          </td>
        </ng-container>

        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            Mobile
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{element.Mobile}}
          </td>
        </ng-container>

        <ng-container matColumnDef="registrationNumber">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            Registration Number
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.Name }}</td>
        </ng-container>

        <ng-container matColumnDef="phoneno">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            Phone No
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            261-{{ element.Mobile }}
          </td>
        </ng-container>


        <ng-container matColumnDef="panNumber">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            PanNumber
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{element.Name}}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            address
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            414-{{element.Name}}
          </td>
        </ng-container> -->

        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            City
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            Surat
          </td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            States
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            Gujarat
          </td>
        </ng-container>

        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            Country
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            India
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            Action
          </th>
          <td mat-cell *matCellDef="let element" class="action-link">
            <a class="m-r-10 cursor-pointer" (click)="editDialog(element.id)">
              <i-tabler name="edit" class="icon-18"></i-tabler>
            </a>
            <a class="m-r-10 cursor-pointer" (click)="deleteDialog(element.id)">
              <i-tabler name="trash" class="icon-18"></i-tabler>
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>